<template>
    <form
        @submit.prevent="editMerchant"
        :action="urls.update"
        method="post"
        enctype="multipart/form-data"
    >
        <div class="divide-y">
            <div class="p-4 space-y-4">
                <text-input
                    label="Business Name"
                    name="name"
                    type="text"
                    placeholder="Bob's Firewood"
                    v-model="form.name"
                    :error="form.errors.name"
                />

                <text-area-input
                    label="Business Description"
                    name="description"
                    placeholder="Operated as a local business for 50 years..."
                    rows="10"
                    :value="form.description"
                    :error="form.errors.description"
                />

                <file-input
                    label="Photo"
                    name="photo"
                    for="photo"
                    accept="image/png, image/jpeg, image/png, image/jpg"
                    :value="form.photo"
                    :error="form.errors.photo"
                />

                <div class="text-sm text-gray-800">Photos must be a minimum of <b>800x800</b> pixels.</div>

                <div
                    v-if="photo"
                    class="sm:w-1/2"
                >
                    <img :src="photo">
                </div>



                <text-input
                    label="PayPal Email"
                    name="paypal_email"
                    type="text"
                    placeholder="pay-me-for-firewood@gmail.com"
                    :value="form.paypal_email"
                    :error="form.errors.paypal_email"
                />

                <div class="text-sm text-gray-800">Your PayPal email is the PayPal account we send your payments to, and is NOT displayed to other users.</div>

            </div>

            <div class="p-4 flex justify-end">
                <button
                    type="submit"
                    class="btn btn-green"
                >
                    Submit
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import TextInput from './shared/TextInput.vue'
export default {
    props: {
        urls: {
            type: Object,
            required: true,
        },
        merchant: {
            type: Object,
            required: true,
        }
    },
    components: {
        TextInput
    }
}
</script>
